import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import useAuthStore from "../stores/authStore";
import useInitialState from "./useInitialState";

export default function useAlreadyLoggedIn() {
  useInitialState();
  const isLoggedIn = useAuthStore((s) => s.isLoggedIn);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isLoggedIn) {
      if (!location.pathname.includes("complete-profile")) {
        navigate(location.state?.from || "/dashboard/create-bill-of-material");
      }
    }
  }, [location, isLoggedIn, navigate]);
}
